import axios from 'axios'
import wcs from './index'
import axiosInstance from "../../../axios-mocks/mock-api/axiosMockApi"
const { storeId, langId, catalogId } = wcs.getStoreConfig()

import { isLocalHost } from "../utils/url"
import {CNC_SHIPPING_DATA_KEY} from '@libs/utils/const'
export const getProductAvailability = async (productId: string) => {
  const { storeId } = wcs.getStoreConfig()
  const origin = window.location.origin
  const url = `${origin}/wcs/resources/store/${storeId}/inventoryavailability/${productId}`
  const res = await axios.get(url)
  return res.data.InventoryAvailability[0].availableQuantity
}

export const setSizeActive = (element: any) => {
  const sizeList = window.productDataSize
  sizeList.forEach((sizeElement: any) => {
    if (sizeElement.currentSkuID == element.currentSkuID) {
      sizeElement.activeSizeClass = 'pdp-slide-menu-filter-list__item--active'
    } else {
      sizeElement.activeSizeClass = ''
    }
  })
}

export const loadProductSizes = async (productId: string) => {
  const { storeId } = wcs.getStoreConfig()
  const origin: string = window.location.origin
  const mockUrl: string = 'mock-api/typescript/product/variants-size'
  const liveUrl: string = `${origin}/wcs/resources/store/${storeId}/products/${productId}/variants/size?langId=${langId}`
  const url: string = isLocalHost() ? mockUrl : liveUrl
  const axiosInitiator = isLocalHost() ? axiosInstance : axios
  const response = await axiosInitiator.get(url)
  return response.data?.result?.sizes || response.data || []
}

export const addToBagPdp = async (productId: string, hasEngraving: boolean = false, isAvailableQuantityMoreThanZero: boolean = true, quantity: number = 1, shippingId: string = '') => {
  const checkInventoryAvailability = isAvailableQuantityMoreThanZero ? 'Y' : 'N'
  const requestUrl: string = '/webapp/wcs/stores/servlet/AjaxOrderChangeServiceItemAdd'
  const formDataAddToBag: any = new FormData()
  let isEditedProduct: boolean = false
  formDataAddToBag.append('storeId', storeId)
  formDataAddToBag.append('langId', langId)
  formDataAddToBag.append('orderId', '.')
  formDataAddToBag.append('calculationUsage', '-1,-2,-3,-4,-5,-6,-7')
  formDataAddToBag.append('catalogAssortment', 'SGH')
  formDataAddToBag.append('PromoFromCookie', '')
  formDataAddToBag.append('srtoken', 'false')
  formDataAddToBag.append('page', 'pdp')
  formDataAddToBag.append('catalogOrigin', '')
  formDataAddToBag.append('catEntryId', productId)
  formDataAddToBag.append('quantity', quantity)
  formDataAddToBag.append('doInventory', checkInventoryAvailability)
  try {
    if (!isAvailableQuantityMoreThanZero) throw new Error('Product not available')
    const searchParams = new URLSearchParams(window.location.search)
    const isEngravingEdited: boolean = searchParams.has('engravedFlag')
    const cartOrderItemId: string = searchParams.get('orderItem') || ''

    //this call for apply engraving to order
    if(hasEngraving) {
      if (isEngravingEdited && cartOrderItemId) {
        isEditedProduct = true
        await addEngravingInCart(cartOrderItemId)
      }
    }

    //remove product from cart if you return from checkout but have no engraving
    if(sessionStorage.getItem('engravingDeleted')) {
      isEditedProduct = true
      await deleteEngravingInCart(cartOrderItemId)
    }

    if (!isEditedProduct) {
      const response = await axios.post(requestUrl, formDataAddToBag)
      const orderItemId = response.data.orderItemId
      if (hasEngraving) {
        await addEngravingInCart(orderItemId)
      }
      localStorage.setItem('SGH_ORDERID', response.data.orderId[0])
      await addToBagPdpDataCalculate(orderItemId) //TODO: check if maybe we can avoid await for this call
    }

    if(!isAvailableQuantityMoreThanZero && shippingId) {
      OrderItemAddressShipMethodUpdate(shippingId)
    }

    return
  } catch (error) {
    console.error('Error adding to bag:', error)
    throw error
  }
}

async function addToBagPdpDataCalculate(orderItemId: string) {
  const requestUrl: string = '/webapp/wcs/stores/servlet/AjaxOrderCalculate'
  const formDataCalculate: any = new FormData()
  formDataCalculate.append('storeId', storeId)
  formDataCalculate.append('langId', langId)
  formDataCalculate.append('updatePrices', '1')
  formDataCalculate.append('orderId[]', orderItemId)
  formDataCalculate.append('calculationUsage', '-1,-2,-3,-4,-5,-6,-7')
  return axios.post(requestUrl, formDataCalculate)
}

export const getEngravingData = async (id: string, urlIndex = 1) => {
  const { storeId } = wcs.getStoreConfig()
  let resp = null
  if (isLocalHost()) {
    resp = (await axiosInstance.get('mock-api/typescript/engravind-data')).data.result
  } else {
    const url =
      urlIndex === 1
        ? `/wcs/resources/store/${storeId}/engraving/temp/${id}`
        : `/wcs/resources/store/${storeId}/engraving/order-item/${id}`
    try {
      resp = (await axios.get(url)).data
    } catch (error) {
      throw new Error(
        'Error on retrieving engraving data with function getEngravingData',
        { cause: error instanceof Error ? error : undefined }
      )
    }
  }
  return resp
}

export const applyEngraving = (wholeObj: any, data: any) => {
  const { storeId } = wcs.getStoreConfig()
  const urlPath = `/wcs/resources/store/${storeId}/engraving/tmp_write/@self?time=${new Date().getTime()}`
  const engraving = {
    ...wholeObj,
    positions: data,
  }
  const serializedObj = JSON.stringify(engraving)

  const res = axios.post(urlPath, serializedObj, { headers: { 'Content-Type': 'application/json' } })
  return res
}



export const addEngravingInCart = async (orderItemId: string) => {
  const { storeId } = wcs.getStoreConfig()
  const restEngravingEndPoint = `/wcs/resources/store/${storeId}/engraving/write/${orderItemId}`
  const dataFromStorage = sessionStorage.getItem('engravingInfo') || ''
  const engravindData = JSON.parse(dataFromStorage)?.engravingData?.allData?.engravingJson

  await axios.post(restEngravingEndPoint, JSON.stringify(engravindData), { headers: { 'Content-Type': 'application/json' } })
}
export const deleteEngravingInCart = async (orderItemId: string) => {
  const { storeId } = wcs.getStoreConfig()
  const restEngravingEndPoint = `/wcs/resources/store/${storeId}/engraving/delete/${orderItemId}`
  sessionStorage.removeItem('engravingInfo')
  sessionStorage.removeItem('engravingDeleted')
  await axios.post(restEngravingEndPoint, { headers: { 'Content-Type': 'application/json' } })
}
export const OrderItemAddressShipMethodUpdate = async (shipModeId: string) => {
  const serviceURL = '/webapp/wcs/stores/servlet/AjaxOrderChangeServiceShipInfoUpdate'
  const { storeId, langId, catalogId } = wcs.getStoreConfig()
  const formDataCalculate: any = new FormData()
  formDataCalculate.append('storeId', storeId)
  formDataCalculate.append('langId', langId)
  formDataCalculate.append('catalogId', catalogId)
  formDataCalculate.append('orderId', '.')
  formDataCalculate.append('calculationUsage', '-1,-2,-3,-4,-5,-6,-7')
  formDataCalculate.append('allocate', '***')
  formDataCalculate.append('backorder', '***')
  formDataCalculate.append('remerge', '***')
  formDataCalculate.append('check', '*n')
  formDataCalculate.append('doInventory', 'N')
  formDataCalculate.append('shipModeId', shipModeId)
  return axios.post(serviceURL, formDataCalculate)
}

export const AjaxSGHOrderOmniChannelShippingInfo = async (SGHOrderOmniChannelParams: any, redirectUrl: string) => {
  const { orderId, orderType, physicalStoreId, physicalStoreZipcode, storeId} = SGHOrderOmniChannelParams
  const serviceURL = `/webapp/wcs/stores/servlet/AjaxSGHOrderOmniChannelShippingInfo?orderId=${orderId}&orderType=${orderType}&physicalStoreId=${physicalStoreId}&physicalStoreZipcode=${physicalStoreZipcode}&storeId=${storeId}`
  const res = await axios.get(serviceURL)
  localStorage.setItem(CNC_SHIPPING_DATA_KEY, JSON.stringify(res.data))
  window.location.href = redirectUrl
}

export const seoProductData = (productId: string) => {
  const { storeId, langId } = wcs.getStoreConfig()

  return axios.get(`/wcs/resources/store/${storeId}/products/${productId}/head?langId=${langId}`).then((response) => {

    const { head } = response.data

    if (response.data.title) {
      document.title = response.data.title
    }

    const updateMeta = (attributes: Record<string, string>) => {
      let meta = null

      if (attributes.name) {
        meta = document.querySelector(`meta[name="${attributes.name}"]`)
      } else if (attributes.property) {
        meta = document.querySelector(`meta[property="${attributes.property}"]`)
      } else if (attributes.charset) {
        meta = document.querySelector(`meta[charset]`)
      } else if (attributes['http-equiv']) {
        meta = document.querySelector(`meta[http-equiv="${attributes['http-equiv']}"]`)
      }

      if (!meta) {
        return
      }

      Object.entries(attributes).forEach(([key, value]) => {
        meta.setAttribute(key, value)
      })
    }

    const updateLink = (attributes: Record<string, string>) => {
      const selectorParts = []
      if (attributes.rel) selectorParts.push(`[rel="${attributes.rel}"]`)
      if (attributes.hreflang) selectorParts.push(`[hreflang="${attributes.hreflang}"]`)
      if (attributes.sizes) selectorParts.push(`[sizes="${attributes.sizes}"]`)

      const selector = selectorParts.join('')

      let link = document.querySelector(`link${selector}`)

      if (!link) {
        return
      }

      Object.entries(attributes).forEach(([key, value]) => {
        link.setAttribute(key, value)
      })
    }

    if (head.meta) {
      head.meta.forEach((metaData: { [x: string]: any, charset: any, name: any, content: any, property: any }) => {
        if (metaData.charset) {
          updateMeta({ charset: metaData.charset })
        } else if (metaData.name) {
          updateMeta({ name: metaData.name, content: metaData.content })
        } else if (metaData['http-equiv']) {
          updateMeta({ 'http-equiv': metaData['http-equiv'], content: metaData.content })
        } else if (metaData.property) {
          updateMeta({ property: metaData.property, content: metaData.content })
        }
      })
    }

    if (head.links) {
      head.links.forEach((linkData: { rel: any, href: any, crossorigin: string }) => {
        const attributes: Record<string, string> = { rel: linkData.rel, href: linkData.href }
        if (linkData.crossorigin) {
          attributes.crossorigin = linkData.crossorigin
        }
        updateLink(attributes)
      })
    }

    if (head.canonical_link) {
      updateLink({ rel: 'canonical', href: head.canonical_link.href })
    }

    if (head.alternate_links) {
      head.alternate_links.forEach((alternateLink: { hreflang: any, href: any }) => {
        updateLink({
          rel: 'alternate',
          hreflang: alternateLink.hreflang,
          href: alternateLink.href,
        })
      })
    }

    if (head.apple_touch_icons) {
      head.apple_touch_icons.forEach((icon: { size: any, href: any }) => {
        updateLink({
          rel: 'apple-touch-icon',
          sizes: icon.size,
          href: icon.href,
        })
      })
    }

    return response.data
  })
}
